import { render, staticRenderFns } from "./addDecisionModel.vue?vue&type=template&id=49fa61d0&scoped=true"
import script from "./addDecisionModel.vue?vue&type=script&lang=js"
export * from "./addDecisionModel.vue?vue&type=script&lang=js"
import style0 from "./addDecisionModel.vue?vue&type=style&index=0&id=49fa61d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fa61d0",
  null
  
)

export default component.exports